"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsPopup = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const NotificationList_1 = require("../../../features/NotificationCenter/components/NotificationList");
const models_1 = require("../../../models");
const updateNotificationStatus_1 = require("../../NotificationCenter/api/updateNotificationStatus");
const getNotificationList_1 = require("../api/getNotificationList");
const useLoadMoreNotificationsOnScroll_1 = require("../hooks/useLoadMoreNotificationsOnScroll");
exports.testIds = {
    loader: 'notification_widget-list-loader',
    loadMoreBtn: 'notification_widget-list-load_more',
    content: 'notification_widget-content',
    loadMorePlaceholder: 'notification_widget-list-load-more',
    scrollLoader: 'notification_widget-list-scroll-loader',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    popupContent: {
        overflow: 'auto',
        alignItems: 'normal',
        justifyContent: 'flex-start',
    },
    loadMoreButton: {
        margin: theme.spacing(3, 0),
    },
}));
const NotificationsPopup = ({ open, anchorEl, onClose, app = models_1.WebsocketApp.ship, }) => {
    const classes = useStyles();
    const theme = (0, silhouette_core_1.useTheme)();
    const history = (0, react_router_dom_1.useHistory)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const observerElem = (0, react_1.useRef)(null);
    const isTinyScreen = (0, silhouette_core_1.useMediaQuery)(theme.breakpoints.down('xs'));
    const notificationResponse = (0, getNotificationList_1.useNotificationList)();
    const updateNotifications = (0, updateNotificationStatus_1.useUpdateNotificationStatus)();
    const { data, isLoading, isFetchingNextPage, hasNextPage } = notificationResponse;
    (0, useLoadMoreNotificationsOnScroll_1.useLoadMoreNotificationsOnScroll)(observerElem, notificationResponse);
    const notificationListPages = data?.pages || [];
    let notificationList = [];
    notificationListPages.forEach((page) => {
        if (page.results.length > 0) {
            notificationList = [...notificationList, ...page.results];
        }
    });
    const markAllAsRead = () => {
        const ids = notificationList
            .filter((notification) => notification.status !== notification_center_models_1.UserNotificationStatus.Read)
            .map((d) => d.id);
        if (ids.length) {
            updateNotifications.mutate({
                ids,
                status: notification_center_models_1.UserNotificationStatus.Read,
            });
        }
    };
    const placementProps = app === models_1.WebsocketApp.ship
        ? {
            placement: 'bottom',
            offset: { top: 8 },
        }
        : {
            placement: 'right-end',
            offset: { left: 4, bottom: 4 },
        };
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Popup, { open: open, anchorEl: anchorEl, onClickAway: onClose, width: isTinyScreen ? `calc(100vw - ${theme.spacing(1)}px)` : 449, height: 515, placement: placementProps.placement, offset: placementProps.offset, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.PopupHeader, { justifyContent: "end", height: 52, borderBottom: "none", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Button, { onClick: markAllAsRead, disabled: isFetchingNextPage || isLoading || !notificationList.length, "data-tracking-id": "notification_widget-notification_list-mark_all_read_button", children: translate('notification_widget-mark_all_as_read') }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.PopupContent, { className: classes.popupContent, "data-testid": exports.testIds.content, children: isLoading ? ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", height: "100%", "data-testid": exports.testIds.loader, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.CircularProgress, {}) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(NotificationList_1.NotificationList, { list: notificationList || [], onSelectNotification: onClose, identifier: "notification_widget" }), hasNextPage && ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { pt: 1, display: "flex", justifyContent: "center", "data-testid": exports.testIds.loadMorePlaceholder, ref: observerElem, children: isFetchingNextPage && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.CircularProgress, { "data-testid": exports.testIds.scrollLoader, size: 12 }), " \u00A0", ' ', (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "caption", children: translate('notification_widget-loading') })] })) }))] })) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.PopupFooter, { sx: { background: theme.palette.background.default }, height: 52, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Button, { fullWidth: true, sx: { height: '100%' }, onClick: () => {
                        history.push('/notification-center');
                        onClose();
                    }, "data-tracking-id": "notification_widget-notification_list-show_all_button", children: translate('notification_widget-list-show_all') }) })] }));
};
exports.NotificationsPopup = NotificationsPopup;
//# sourceMappingURL=NotificationsPopup.js.map